import _ from 'lodash';

export const hasPermission = (matches, userScopes = []) => {
  if (userScopes.includes('*')) return true;
  if (!matches?.length) return false;

  return matches.every(({ route }) => {
    const scopes = route?.scopes;
    // if (!Array.isArray(scopes) || scopes.length === 0) {
    //   console.log('Ruta pública (sin scopes)');
    // } else {
    //   console.table(
    //     scopes.map((scope) => ({
    //       required: scope,
    //       user_ok: userScopes.includes(scope),
    //     }))
    //   );
    // }
    if (!Array.isArray(scopes) || scopes.length === 0) return true;
    return scopes.some((s) => userScopes.includes(s));
  });
};

export const filterAsyncRoutes = (nav, scopes) => {
  const includesAll = scopes.includes('*');
  if (includesAll) {
    return nav;
  }
  return nav
    .map((_item) => {
      if (_item.scopes && _item.scopes.length > 0) {
        if (!scopes.some((scope) => _item.scopes.includes(scope))) {
          return null;
        }
      }
      if (_item.children) {
        const filteredChildren = filterAsyncRoutes(_item.children, scopes);
        if (filteredChildren.every((child) => child === null)) {
          return null;
        }
        return { ..._item, children: filteredChildren };
      }
      return { ..._item };
    })
    .filter((s) => s !== null);
};

export const matchingRoutesToNav = (currentNavBarRoutes, currentRoutes) => {
  return currentNavBarRoutes.reduce((filteredRoutes, route) => {
    const navBarRouteRef = { ...route };

    if (navBarRouteRef.children) {
      navBarRouteRef.children = matchingRoutesToNav(navBarRouteRef.children, currentRoutes);
    }

    const isRouteMatched = currentRoutes.some((historyRouteItem) => {
      return checkIfRouteMatches(historyRouteItem, navBarRouteRef);
    });

    if (isRouteMatched) {
      filteredRoutes.push(navBarRouteRef); // Agregar la ruta si coincide con alguna en rutasHistory
    }
    return filteredRoutes;
  }, []);
};

const checkIfRouteMatches = (historyRouteItem, navBarRouteRef) => {
  if (
    historyRouteItem.id === navBarRouteRef.id ||
    // navBarRouteRef.type === 'group' ||
    navBarRouteRef.id.includes('scope_none') ||
    (_.has(navBarRouteRef, 'bypass') && navBarRouteRef.bypass === true)
  ) {
    return true;
  }
  if (historyRouteItem.children) {
    // Si historyRouteItem tiene children, iteramos sobre ellos y comprobamos si alguno coincide
    return historyRouteItem.children.some((childRoute) =>
      checkIfRouteMatches(childRoute, navBarRouteRef)
    );
  }
  return false;
};

// ----- Extracted from Wd core --------

export const setRoutes = (config) => {
  let routes = [...config.routes];

  routes = routes.map((route) => {
    const settings = _.merge({}, config.settings, route.settings);
    let scopes;
    if (config.scopes) {
      scopes = config.scopes;
    } else if (route.scopes) {
      scopes = route.scopes;
    } else {
      scopes = undefined;
    }

    return {
      ...route,
      settings,
      scopes,
    };
  });

  return [...routes];
};

export const generateRoutesFromAsyncList = (asyncRoutes) => {
  let allRoutes = [];
  asyncRoutes.forEach((asyncRoute) => {
    allRoutes = [...allRoutes, ...setRoutes(asyncRoute)];
  });
  return allRoutes;
};
